module.exports = __webpack_public_path__ + "static/media/create_sections_subsections_and_inclusion.1f9491f6.mov";